/* eslint-disable react-hooks/exhaustive-deps */
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import queryString from "query-string";

import { auth } from "../../../utils/auth";
import { formatCurrency } from "../../../utils/helpers";
import { request } from "../../../utils/request";

const params = queryString.parse(window.location.search);

const PrintResumenCuentasPorCobrar = () => {
	const [cuentas, setCuentas] = useState([]);
	const [cuentasRaw, setCuentasRaw] = useState([]);
	const [sample, setSample] = useState({});
	const [sumatorias, setSumatorias] = useState({});
	const [totalCxC, setTotalCxC] = useState(0);
	const [cantidadCxC, setCantidadCxC] = useState(0);
	const [listo, setListo] = useState(false);

	const getCuentas = () => {
		request(
			"cuentas-por-cobrar" +
				window.location.search +
				"&paginate=100000&sortBy=cliente"
		).then((res) => {
			processCuentasData(res.data);
			setSample(res.data[0]);
			setListo(true);
		});
	};

	const formatDateTime = (date) => {
		return dayjs(date).format("DD/MM/YYYY, hh:mm a");
	};

	const processCuentasData = (data) => {
		const cuentasSegmentadas = {};
		const sumatoriasSegmentadas = {};
		let totalCxCCurrent = 0;
		data.forEach((cuenta) => {
			totalCxCCurrent += parseFloat(cuenta?.por_cobrar);
			if (
				cuenta.cliente?.id &&
				!cuentasSegmentadas.hasOwnProperty(cuenta.cliente?.nombre)
			) {
				cuentasSegmentadas[cuenta.cliente?.nombre] = [cuenta];
				sumatoriasSegmentadas[cuenta.cliente?.nombre] = parseFloat(
					cuenta?.por_cobrar
				);
			} else if (
				cuentasSegmentadas.hasOwnProperty(cuenta.cliente?.nombre)
			) {
				cuentasSegmentadas[cuenta.cliente?.nombre].push(cuenta);
				sumatoriasSegmentadas[cuenta.cliente?.nombre] += parseFloat(
					cuenta?.por_cobrar
				);
			}

		});

		setCantidadCxC(data.length);
		setTotalCxC(totalCxCCurrent);
		setSumatorias(sumatoriasSegmentadas);
		setCuentas(cuentasSegmentadas);
		setCuentasRaw(data);
	};

	useEffect(() => {
		getCuentas();
	}, []);

	// Espera a que el estado con los datos ya esté reflejado en el DOM
	// antes de abrir el diálogo de impresión.
	useEffect(() => {
		if (listo) {
			window.print();
		}
	}, [listo]);

	const user = auth.getUser();
	const sucursal = user.sucursales.filter(
		(suc) => suc.id === user.sucursalActual
	)[0];
	// const valorTotal = cuentas.reduce((acc, factura) => {
	// 	return acc + parseFloat(factura.por_cobrar);
	// }, 0);

    const totalProcesando = cuentasRaw?.filter(f => f.estado === 'procesando').reduce((acc, factura) => acc + parseFloat(factura.por_cobrar), 0);

	return (
		<>
			<div className="row">
				<h3 className="col-md-12 text-center m-b-5">
                    {sucursal.nombre}
				</h3>
                <div className="col-md-12 text-center uppercase"><strong>Resumen Cuentas Por Cobrar</strong></div>
				<div className="col-md-12 text-center">
                    {sucursal.direccion} •{" "}
					{new Date().toLocaleString()}
				</div>
                <div className="col-md-12 p-t-5 p-b-10 text-center">
                    {Object.keys(params).map(k => {
                        switch (k) {
                            case 'categoria':
                                return `${k.toUpperCase()}: "${sample.categorias && sample.categorias[0].nombre}"`;
                            case 'zona':
                                return `${k.toUpperCase()}: "${sample.ruta?.nombre}"`;
                            case 'vendedor':
                                return `${k.toUpperCase()}: "${sample.vendedor?.nombre} ${sample.vendedor?.apellido}"`;
                            default:
                                return `${k.toUpperCase()}: "${params[k]}"`;
                        }
                    }).join(' • ')}
                </div>
				<div className="col-md-12 text-right p-b-10">
					<div className="float-left">
						TOTAL CUENTAS POR COBRAR: {cantidadCxC}
					</div>

					<div className="float-right" style={{lineHeight: 1.2}}>
						<div className="bold">BALANCE TOTAL: {formatCurrency(totalCxC)}</div>
						<div className="bold">PROCESANDO: {formatCurrency(totalProcesando)}</div>
						<div className="bold">BALANCE ACTUALIZADO: {formatCurrency(totalCxC - totalProcesando)}</div>
					</div>
				</div>
			</div>
			{Object.keys(cuentas).map((cliente) => {
                const cuentaMap = cuentas[cliente];
                const vendedor = cuentaMap[0].vendedor ? `${cuentaMap[0].vendedor?.nombre} ${cuentaMap[0].vendedor?.apellido}` : '';
                return (
                    <>
                        <h3>{cliente} {vendedor && `- Vendedor: ${vendedor}`}</h3>
                        <table className="table mb-0" style={{tableLayout: 'fixed'}}>
                            <thead>
                                <tr>
                                    <th>NCF/Numero</th>
                                    <th>Tipo</th>
                                    <th>Estado</th>
                                    <th width="200px">Creación</th>
                                    <th className="text-right">Vencimiento</th>
                                    <th className="text-right">Plazo</th>
                                    <th className="text-right">Transcurrido</th>
                                    <th className="text-right">Monto</th>
                                    <th className="text-right">Balance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cuentaMap.map((cuenta) => {
                                    const cheque = cuenta.cheques?.find(c => c.status === 'procesando');
                                    return (
                                        <tr key={cuenta.id}>
                                            <td>
                                                <div>{cuenta.numero_comprobante}</div>
                                                {cuenta.tipo_pago === 'cheque' && cheque && (
                                                    <div style={{whiteSpace: 'nowrap'}}><small className="uppercase">Cheque: </small> {cheque.numero} - <small className="uppercase">Monto: </small>{formatCurrency(cheque.monto)}</div>
                                                )}
                                            </td>
                                            <td className="text-capitalize">
                                                {cuenta.tipo}
                                            </td>
                                            <td>
                                                <span className="uppercase">{cuenta.estado}</span>
                                            </td>
                                            <td>
                                                {!!cuenta.recurrencia_id
                                                    ? dayjs(cuenta.fecha).format(
                                                            "DD/MM/YYYY"
                                                    )
                                                    : formatDateTime(
                                                            cuenta.created_at
                                                    )}{" "}
                                            </td>
                                            <td className="text-right">
                                                {dayjs(
                                                    cuenta.fecha_vencimiento
                                                ).format("DD/MM/YYYY")}
                                            </td>
                                            <td className="text-capitalize text-right">
                                                {cuenta.plazo?.dias} Días
                                            </td>
                                            <td className="text-right">
                                                <div>
                                                    {!!cuenta.recurrencia_id
                                                        ? dayjs()
                                                                .startOf("day")
                                                                .diff(
                                                                    dayjs(
                                                                        cuenta.fecha
                                                                    ).startOf(
                                                                        "day"
                                                                    ),
                                                                    "day"
                                                                )
                                                        : dayjs()
                                                                .startOf("day")
                                                                .diff(
                                                                    dayjs(
                                                                        cuenta.created_at
                                                                    ).startOf(
                                                                        "day"
                                                                    ),
                                                                    "day"
                                                                )}{" "}
                                                    días
                                                </div>
                                            </td>
                                            <td className="text-right">
                                                {formatCurrency(cuenta.total)}
                                            </td>
                                            <td className="text-right">
                                                {formatCurrency(cuenta.por_cobrar)}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                        <div className="d-flex mb-4">
                            <strong className="ml-auto mr-1">Balance total: {formatCurrency(cuentaMap.reduce((acc, cuenta) => acc + cuenta.por_cobrar, 0))}</strong>
                        </div>
                    </>
			    )
            })}
            <div className="p-b-10">
                <div className="float-left">
                    TOTAL CUENTAS POR COBRAR: {cantidadCxC}
                </div>

                <div className="float-right text-right" style={{lineHeight: 1.2}}>
                    <div className="bold">BALANCE TOTAL: {formatCurrency(totalCxC)}</div>
                    <div className="bold">PROCESANDO: {formatCurrency(totalProcesando)}</div>
                    <div className="bold">BALANCE ACTUALIZADO: {formatCurrency(totalCxC - totalProcesando)}</div>
                </div>
            </div>
		</>
	);
};

export default PrintResumenCuentasPorCobrar;
